import React, { useEffect, useState } from 'react';
import { getStoreSettings } from '../services/api';
import { formatWhatsAppNumber } from '../utils/pricing';
import './WhatsAppButton.css';

function WhatsAppIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347Z" />
      <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.175L2 22l4.95-1.3A9.96 9.96 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2Zm0 18a7.96 7.96 0 0 1-4.074-1.12l-.293-.175-2.934.77.784-2.86-.192-.3A7.96 7.96 0 0 1 4 12c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8Z" />
    </svg>
  );
}

function WhatsAppButton() {
  const [whatsappUrl, setWhatsappUrl] = useState(null);

  useEffect(() => {
    getStoreSettings().then((settings) => {
      const number = formatWhatsAppNumber(settings?.storePhone);
      if (number) {
        const message = encodeURIComponent('Hello! I have a question about your store.');
        setWhatsappUrl(`https://wa.me/${number}?text=${message}`);
      }
    });
  }, []);

  if (!whatsappUrl) return null;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat on WhatsApp"
    >
      <WhatsAppIcon />
      <span className="whatsapp-label">WhatsApp</span>
    </a>
  );
}

export default WhatsAppButton;
